import type React from 'react';

export function EaseInOutView({ active, children }: React.PropsWithChildren<{ active: boolean }>) {
  return (
    <div
      className='transition-all duration-500 ease-in-out'
      style={{
        transform: active ? 'translateX(0)' : 'translateX(100%)',
        opacity: active ? 1 : 0,
        position: active ? 'relative' : 'absolute',
        width: '100%',
      }}
    >
      {children}
    </div>
  );
}
